(() => {
  'use strict';
  if (document.documentElement.dataset.nmQuickAddReady) return;
  const dialog = document.querySelector('[data-nm-quick-add-dialog]');
  const labelNode = document.getElementById('nm-quick-add-labels');
  if (!dialog || !labelNode) return;
  const labels = JSON.parse(labelNode.textContent);
  const title = dialog.querySelector('[data-nm-quick-add-title]');
  const media = dialog.querySelector('[data-nm-quick-add-media]');
  const price = dialog.querySelector('[data-nm-quick-add-price]');
  const options = dialog.querySelector('[data-nm-quick-add-options]');
  const submit = dialog.querySelector('[data-nm-quick-add-submit]');
  const details = dialog.querySelector('[data-nm-quick-add-details]');
  const errorNode = dialog.querySelector('[data-nm-quick-add-error]');
  let product = null;
  let variants = [];
  let selection = [];
  let colourIndex = -1;
  let sizeIndex = -1;
  let opener = null;
  let busy = false;
  let scrollLocked = false;
  let previousOverflow = '';
  const pendingCards = new WeakSet();

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  };
  const safeUrl = (value, local = false) => {
    try {
      const url = new URL(value, location.origin);
      if (!['http:', 'https:'].includes(url.protocol) || (local && url.origin !== location.origin)) return '';
      return url.href;
    } catch { return ''; }
  };
  const matches = (variant, values = selection, skip = -1) => values.every((value, index) => index === skip || value === null || variant.options[index] === value);
  const chosenVariant = () => {
    if (selection.some(value => value === null)) return null;
    return variants.find(variant => matches(variant)) || null;
  };
  const showError = message => {
    errorNode.textContent = message || '';
    errorNode.hidden = !message;
  };
  const unlockScroll = () => {
    if (!scrollLocked) return;
    document.body.style.overflow = previousOverflow;
    scrollLocked = false;
  };
  const close = (restoreFocus = true) => {
    if (dialog.open) dialog.close();
    unlockScroll();
    if (restoreFocus && opener?.isConnected) opener.focus({ preventScroll: true });
  };
  const show = () => {
    if (!dialog.open) {
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      scrollLocked = true;
    }
    title.focus({ preventScroll: true });
  };
  const displayImage = variant => {
    const colour = colourIndex >= 0 ? selection[colourIndex] : null;
    const related = colour === null ? variants : variants.filter(entry => entry.options[colourIndex] === colour);
    const source = safeUrl(variant?.image || related.find(entry => entry.image)?.image || product.image || '');
    const existing = media.querySelector('img');
    if (source && existing?.src === source) return;
    media.replaceChildren();
    if (!source) return;
    const image = element('img');
    image.src = source;
    image.alt = colour ? `${product.title} — ${colour}` : product.title;
    image.width = 420;
    image.height = 560;
    image.decoding = 'async';
    media.append(image);
  };
  const render = focusChoice => {
    const selected = chosenVariant();
    const candidates = selected ? [selected] : variants.filter(variant => matches(variant));
    const available = candidates.some(variant => variant.available);
    const priced = [...candidates].sort((left, right) => left.price - right.price);
    const displayed = selected || priced[0];
    price.replaceChildren();
    if (displayed) {
      const varies = candidates.some(variant => variant.price !== displayed.price);
      if (varies) price.append(element('span', 'nm-quick-add__from', labels.from));
      price.append(element('strong', '', displayed.price_formatted));
      const sameCompare = candidates.every(variant => variant.compare_at_price === displayed.compare_at_price);
      if (!varies && sameCompare && displayed.compare_at_price > displayed.price) price.append(element('s', '', displayed.compare_formatted));
    }
    options.replaceChildren();
    if (!product.has_only_default_variant) product.options.forEach((option, index) => {
      const fieldset = element('fieldset');
      const legend = element('legend', '', `${option.name}: `);
      legend.append(element('span', '', selection[index] || labels.select));
      fieldset.append(legend);
      const choices = element('div', 'nm-quick-add__choices');
      if (index === colourIndex) choices.classList.add('nm-quick-add__choices--colours');
      option.values.forEach(value => {
        if (product.sale_only && index === colourIndex && !variants.some(variant => variant.options[index] === value)) return;
        const choice = element('button', 'nm-quick-add__choice', value);
        const swatchStyle = option.swatches?.[value] || product.swatches?.[value];
        if (index === colourIndex && swatchStyle) {
          choice.classList.add('nm-quick-add__choice--swatch');
          choice.replaceChildren();
          const swatch = element('span', 'nm-quick-add__swatch');
          swatch.style.cssText = swatchStyle;
          swatch.setAttribute('aria-hidden', 'true');
          choice.append(swatch, element('span', 'nm-sr-only', value));
          choice.title = value;
        }
        choice.type = 'button';
        choice.dataset.nmQuickAddOption = String(index);
        choice.dataset.value = value;
        choice.setAttribute('aria-pressed', String(selection[index] === value));
        const permitted = variants.some(variant => variant.available && variant.options[index] === value && (index === colourIndex || matches(variant, selection, index)));
        choice.disabled = busy || !permitted;
        if (!permitted) choice.setAttribute('aria-label', `${value} — ${labels.unavailable}`);
        choices.append(choice);
      });
      fieldset.append(choices);
      options.append(fieldset);
    });
    submit.disabled = busy || !selected?.available;
    if (busy) submit.textContent = labels.adding;
    else if (!available) submit.textContent = labels.soldOut;
    else if (selected?.available) submit.textContent = labels.add;
    else submit.textContent = sizeIndex >= 0 && selection[sizeIndex] === null ? labels.chooseSize : labels.chooseOptions;
    const url = new URL(safeUrl(product.url, true) || location.href);
    if (selected) url.searchParams.set('variant', selected.id);
    else if (colourIndex >= 0 && selection[colourIndex]) url.searchParams.set('color', selection[colourIndex]);
    details.href = url.href;
    displayImage(selected || displayed);
    if (focusChoice) [...options.querySelectorAll('[data-nm-quick-add-option]')].find(control => Number(control.dataset.nmQuickAddOption) === focusChoice.index && control.dataset.value === focusChoice.value)?.focus({ preventScroll: true });
  };
  const open = trigger => {
    if (busy) return;
    const card = trigger.closest('[data-nm-card]');
    const data = card?.querySelector('[data-nm-quick-add-data]');
    if (!data) return;
    let incoming;
    try { incoming = JSON.parse(data.textContent); } catch { return; }
    if (!Array.isArray(incoming.options) || !Array.isArray(incoming.variants) || !incoming.variants.length) return;
    product = incoming;
    variants = product.variants.filter(variant => !product.sale_only || Number(variant.compare_at_price) > Number(variant.price));
    if (!variants.length) return;
    colourIndex = product.options.findIndex(option => /^(colour|color)$/i.test(option.name));
    sizeIndex = product.options.findIndex(option => /size/i.test(option.name));
    selection = product.options.map(() => null);
    if (product.has_only_default_variant) selection = [...variants[0].options];
    else if (colourIndex >= 0) {
      const requested = card.dataset.nmColour || product.selected_colour;
      selection[colourIndex] = variants.find(variant => variant.options[colourIndex] === requested)?.options[colourIndex] || (variants.find(variant => variant.available) || variants[0]).options[colourIndex];
    }
    opener = trigger;
    title.textContent = product.title;
    showError('');
    render();
    show();
  };
  document.addEventListener('click', event => {
    const sizeButton = event.target.closest('[data-nm-hover-size]');
    if (sizeButton) {
      event.preventDefault();
      addCardSize(sizeButton);
      return;
    }
    const trigger = event.target.closest('[data-nm-quick-add]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
  const addCardSize = async trigger => {
    const card = trigger.closest('[data-nm-card]');
    if (!card || trigger.disabled || pendingCards.has(card)) return;
    let data;
    try { data = JSON.parse(card.querySelector('[data-nm-quick-add-data]').textContent); } catch { return; }
    const cardColourIndex = data.options.findIndex(option => /^(colour|color)$/i.test(option.name));
    const variant = data.variants.find(entry => Number(entry.id) === Number(trigger.dataset.variantId));
    if (!variant?.available || (data.sale_only && Number(variant.compare_at_price) <= Number(variant.price))) return;
    if (cardColourIndex >= 0 && variant.options[cardColourIndex] !== card.dataset.nmColour) return;
    const status = card.querySelector('[data-nm-card-status]');
    let error = card.querySelector('[data-nm-card-error]');
    const showCardError = message => {
      if (!error) {
        error = element('p', 'nm-card__error');
        error.dataset.nmCardError = '';
        error.setAttribute('role', 'alert');
        card.querySelector('.nm-card__info').append(error);
      }
      error.textContent = message;
      error.hidden = !message;
    };
    if (error) { error.textContent = ''; error.hidden = true; }
    if (!window.ARMATEQCart?.addItems) { showCardError(labels.error); return; }
    pendingCards.add(card);
    card.setAttribute('aria-busy', 'true');
    trigger.setAttribute('aria-busy', 'true');
    if (status) status.textContent = labels.adding;
    const controls = [...card.querySelectorAll('[data-nm-hover-size], [data-nm-quick-add]')].map(control => ({ control, disabled: control.disabled }));
    try {
      const operation = window.ARMATEQCart.addItems([{ id: Number(variant.id), quantity: 1 }]);
      controls.forEach(({ control }) => { control.disabled = true; });
      await operation;
      if (status) status.textContent = labels.added;
    } catch (error) {
      if (status) status.textContent = '';
      if (!error.cartWasModified) showCardError(error.message || labels.error);
    } finally {
      pendingCards.delete(card);
      card.removeAttribute('aria-busy');
      trigger.removeAttribute('aria-busy');
      controls.forEach(({ control, disabled }) => { control.disabled = disabled; });
    }
  };
  dialog.addEventListener('click', event => {
    if (event.target === dialog || event.target.closest('[data-nm-quick-add-close]')) { close(); return; }
    const option = event.target.closest('[data-nm-quick-add-option]');
    if (!option || option.disabled || busy) return;
    const index = Number(option.dataset.nmQuickAddOption);
    selection[index] = option.dataset.value;
    if (index === colourIndex) selection.forEach((value, position) => {
      if (position !== colourIndex && value !== null && !variants.some(variant => variant.available && matches(variant))) selection[position] = null;
    });
    showError('');
    render({ index, value: option.dataset.value });
  });
  dialog.querySelector('[data-nm-quick-add-form]').addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const selected = chosenVariant();
    if (!selected?.available) return;
    if (!window.ARMATEQCart?.addItems) { showError(labels.error); return; }
    busy = true;
    showError('');
    render();
    close();
    const currentOpener = opener;
    const wasDisabled = currentOpener?.disabled;
    if (currentOpener) currentOpener.setAttribute('aria-busy', 'true');
    try {
      const operation = window.ARMATEQCart.addItems([{ id: Number(selected.id), quantity: 1 }]);
      if (currentOpener) currentOpener.disabled = true;
      await operation;
    } catch (error) {
      if (!error.cartWasModified) {
        showError(error.message || labels.error);
        show();
        errorNode.scrollIntoView({ block: 'nearest' });
      }
    } finally {
      busy = false;
      if (currentOpener) {
        currentOpener.disabled = Boolean(wasDisabled);
        currentOpener.removeAttribute('aria-busy');
      }
      render();
    }
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => { if (!dialog.open && scrollLocked) { unlockScroll(); opener?.focus({ preventScroll: true }); } });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), [tabindex="0"]')].filter(control => !control.hidden);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === title || document.activeElement === dialog)) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  document.documentElement.dataset.nmQuickAddReady = 'true';
  document.documentElement.classList.add('nm-quick-add-ready');
})();
